export const PaymentComplete = () => {
  return (
    <div className="vertical-align" style={{ width: "100%" }}>
      <div style={{ width: "100%", textAlign: "center" }}>
        Wow, thank you for joining with us achieve our film making goals!
      </div>
    </div>
  );
};
